import { UIOfferOfferSection } from 'interfaces/ui/ui-offer-offer-section';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import JobOfferSubsection from '../JobOfferSubsection';
import OfferPerks from './OfferPerks';
import { useOfferSection } from './OfferSection.hooks';
import { StyledOfferSection } from './OfferSection.styled';
import OfferSummary from './OfferSummary';

const OfferSection: React.FC<UIOfferOfferSection> = ({
  companyName,
  offerCode,
  offer,
  offerInfo,
  perks,
  migratedToMarkdown
}) => {
  const { t, ref } = useOfferSection({
    companyName,
    offerCode
  });

  return (
    <JobOfferSection name="oferta" sectionBg="alt" title={t('titles.offer')}>
      <StyledOfferSection ref={ref}>
        <OfferSummary
          offer={offer}
          perks={perks}
          migratedToMarkdown={migratedToMarkdown}
        />

        <JobOfferLongText isMarkdown={migratedToMarkdown}>
          {offerInfo}
        </JobOfferLongText>

        {perks && perks.extra.length > 0 && (
          <JobOfferSubsection title={t('offer.perks')}>
            <OfferPerks perks={perks} />
          </JobOfferSubsection>
        )}
      </StyledOfferSection>
    </JobOfferSection>
  );
};

export default OfferSection;
